import ActivityIndicatorSeen from '../../activity-indicator/activity-indicator-seen';
import React, {Component} from 'react';
import classnames from 'classnames';
import {compose} from 'redux';
import queryString from 'query-string';
import {CollaborateButton, CollaboratorDisplay, CollaborateModal, CollaborateType, InviteAccept} from '../../collaborate';
import {CommentsModal} from '../../comments';
import {RecommendedPropertyCarousel} from '../../recommended-properties';
import {TripboardBanner} from '../../tripboard-banner';
import constants, {GOOGLE_MAPS_CHANNEL_ID} from '../../../utils/constants';
import edap from '../../edap';
import ErrorBoundary from './error-boundary';
import FavoritesMessage from './favorites-message';
import PublicSearch from './public-search';
import StayContextContainer from './stay-context-container';
import GenericError from '../../../components/generic-error';
import ListingDeleteModal from '../../listing-delete-modal/ListingDeleteModal';
import {logNoListingUrl} from '../../../utils/logger';
import HeaderWithEditState from './header-with-edit-state';
import Hit from '../../../components/Hit';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import ListingsMap from '../../listings-map/listings-map';
import NoListingsSearch from './no-listings-search';
import PrivateSearch from './private-search';
import NoListingsGraphic from './no-listings-graphic';
import PageView from '../../../components/PageView/PageView';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';
import RolePermissions from '../../../components/permissions';
import routes from '../../../routes';
import TabNavigation from './tab-navigation';
import TestExposureOnce from '../../../abacus/test-exposure-once';
import withAbacusTestValuesAsProps from '../../../abacus/with-abacus-test-values-as-props';
import {withPAR} from '../../../components/Timing';
import {getImageUrl} from '../../../utils/images';

import {
    HA_PULSE_EMPTY_SEARCH_TEST,
    HA_PULSE_PUBLIC_SEARCH_TEST,
    HA_PULSE_GOOGLE_MAP,
    HA_PULSE_REMOVE_BACK_BUTTON_TEST,
    HA_PULSE_SHARED_TRIPBOARD_AB_TEST,
    HA_PULSE_TRIPBOARDS_CAROUSEL_TEST,
    HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE,
    HA_PULSE_SIMILAR_PROPERTIES,
    HA_PULSE_PRIVATE_SEARCH_TEST,
    HA_PULSE_HEART_REMOVE_TEST,
    HA_PULSE_GUEST_CONTEXT_TEST
} from '../../../abacus/experiments';

import './details.less';
import {PAGE_TRIPBOARD_DETAILS, PAGE_TRIPBOARD_DETAILS_MAP} from '../../../utils/edap';

export const testExposureCarousel = new TestExposureOnce(HA_PULSE_TRIPBOARDS_CAROUSEL_TEST);
export const testExposureGoogleMap = new TestExposureOnce(HA_PULSE_GOOGLE_MAP);
export const testExposureSimilarProperties = new TestExposureOnce(HA_PULSE_SIMILAR_PROPERTIES);
export const testExposureEmptySearch = new TestExposureOnce(HA_PULSE_EMPTY_SEARCH_TEST);
export const testExposurePublicSearch = new TestExposureOnce(HA_PULSE_PUBLIC_SEARCH_TEST);
export const testExposurePrivateSearch = new TestExposureOnce(HA_PULSE_PRIVATE_SEARCH_TEST);
export const testExposureHeartRemove = new TestExposureOnce(HA_PULSE_HEART_REMOVE_TEST);
export const testExposureGuestContext = new TestExposureOnce(HA_PULSE_GUEST_CONTEXT_TEST);
export class TripboardDetails extends Component {
    static propTypes = {
        listings: PropTypes.arrayOf(PropTypes.shape),
        locale: PropTypes.string.isRequired,
        renameTripboard: PropTypes.func,
        onDelete: PropTypes.func,
        setCurrentTripboard: PropTypes.func
    };

    static defaultProps = {
        listings: [],
        name: '',
        renameTripboard: () => {},
        role: constants.OWNER,
        onDelete: () => {},
        fetchDetails: () => {},
        setCurrentTripboard: () => {},
        completeTripboardCreation: () => {},
        markPAR: () => {},
        sharedTestValue: 0,
        mapTestValue: 0,
        removeBackButtonTestValue: 0,
        similarPropertiesTestValue: 0
    };

    static formatTripboardDate(date) {
        if (!date) {
            return null;
        }
        const formattedDate = date.split('-');
        formattedDate.push(formattedDate.shift());
        return formattedDate.join('/');
    }

    constructor(props) {
        super(props);
        this.translations = {
            editText: props.translations['tripboards.main.edit'],
            nameText: props.translations['tripboards.modal.create.name'],
            doneText: props.translations['tripboards.done'],
            cancelText: props.translations['tripboards.cancel'],
            clearDatesText: props.translations['tripboards.date_picker.clear_dates'],
            datesText: props.translations['tripboards.date_picker.dates'],
            favoritesList: props.translations['tripboards.favorites.list'],
            favoritesListShared: props.translations['tripboards.favorites.shared_list'],
            errorTitle: props.translations['th.inbox.error.title'],
            errorMessage: props.translations['th.inbox.error.message'],
            copyText: props.translations['tripboards.copy'],
            copiedText: props.translations['tripboards.copied'],
            shareTitle: props.translations['tripboards.share'],
            shareText: props.translations['tripboards.share.text'],
            mapText: props.translations.mapButton,
            listText: props.translations.backToListButton
        };

        this.state = {
            displayIndex: 0
        };
    }

    componentDidMount = () => {
        const {setCurrentTripboard, endDate, listings, loadingState, boardId, startDate} = this.props;
        if (loadingState.isSuccess && boardId) {
            // Fire edap event as data is already loaded
            edap.detailsLoad(boardId, endDate, listings.length, startDate);
            edap.tripboardsView(boardId, this.props.role);
            setCurrentTripboard(boardId);
        }
        this.par(this.props);
    };

    componentDidUpdate(prevProps) {
        if (this.props.loadingState.isSuccess && !prevProps.loadingState.isSuccess) {
            const {
                setCurrentTripboard,
                completeTripboardCreation,
                boardId,
                endDate,
                listings,
                startDate,
                role,
                places
            } = this.props;
            // Fire edap event as we have successfully completed data fetch
            edap.detailsLoad(boardId, endDate, listings.length, startDate);
            edap.tripboardsView(boardId, role);
            const roleLowerCase = role.toLowerCase();
            setCurrentTripboard(boardId);
            completeTripboardCreation();
            if (listings && listings.length > 0) {
                if (!places || places.length === 0) {
                    edap.placesError(boardId, places);
                }
                testExposureCarousel.trigger(HA_PULSE_TRIPBOARDS_CAROUSEL_TEST);
                testExposureGoogleMap.trigger(HA_PULSE_GOOGLE_MAP);
                testExposureSimilarProperties.trigger(HA_PULSE_SIMILAR_PROPERTIES);
                if (roleLowerCase === constants.VIEWER) {
                    testExposurePublicSearch.trigger(HA_PULSE_PUBLIC_SEARCH_TEST);
                } else if (roleLowerCase === constants.OWNER || roleLowerCase === constants.COLLABORATOR) {
                    testExposurePrivateSearch.trigger(HA_PULSE_PRIVATE_SEARCH_TEST);
                    testExposureHeartRemove.trigger(HA_PULSE_HEART_REMOVE_TEST);
                    testExposureGuestContext.trigger(HA_PULSE_GUEST_CONTEXT_TEST);
                }
            } else {
                testExposureEmptySearch.trigger(HA_PULSE_EMPTY_SEARCH_TEST);
            }
        }
        this.par(this.props);
    }

    par = (props = {}) => {
        const {loadingState} = props;
        // PAR definition: When the listings of a tripboard are fully loaded.
        if (!loadingState.isInitial && !loadingState.isStart) {
            this.props.markPAR();
        }
    };

    isOwner = () => {
        return this.props.role.toLowerCase() === constants.OWNER;
    };

    isCollaborator = () => {
        return this.props.role.toLowerCase() === constants.COLLABORATOR;
    };

    isViewer = () => {
        return this.props.role.toLowerCase() === constants.VIEWER;
    };

    showDetails = () => {
        return (
            (this.props.mapTestValue < 2 && this.state.displayIndex === 0) ||
            (this.props.mapTestValue === 2 && this.state.displayIndex === 1)
        );
    };

    onTabClick = (index) => {
        edap.mapTabClicked(this.props.boardId, this.props.mapTestValue, index);
        this.setState({displayIndex: index});
    };

    // Start Abacus: ha_pulse_shared_tripboard_ab_test
    isSharedTestOn = () => {
        const {shareButtonToggleValue} = this.props;
        return shareButtonToggleValue > 0;
    };
    // End Abacus: ha_pulse_shared_tripboard_ab_test

    // Start Abacus: ha_pulse_tripboards_carousel_test
    isCarouselTestOn = () => {
        const {carouselTestValue} = this.props;
        return carouselTestValue > 0;
    };
    // End Abacus: ha_pulse_tripboards_carousel_test

    // Start Abacus: ha_pulse_remove_heart_test
    isRemoveHeartTestOn = () => {
        const {heartRemoveTestValue} = this.props;
        return heartRemoveTestValue > 0;
    };
    // End Abacus: ha_pulse_remove_heart_test

    // Using ha_pulse_remove_back_button_test as a toggle for this feature
    hasBackButton = () => {
        const {removeBackButtonTestValue} = this.props;
        // only hide the back button if a VIEWER is looking at the board
        return !this.isViewer() || removeBackButtonTestValue === 0;
    };

    hasDates = () => {
        const {loadingState} = this.props;

        return !loadingState.isError && !this.isViewer();
    };

    hasDatesInHeader = () => {
        return !this.isSharedTestOn() && this.hasDates();
    };

    hasDatesInBody = () => {
        return this.isSharedTestOn() && this.hasDates();
    };

    hasNameEdit = () => {
        const {loadingState} = this.props;

        return !loadingState.isError && !this.isViewer();
    };

    hasDeleteButton = () => {
        return !this.isViewer();
    };

    hasTripboardButton = () => {
        return this.isViewer();
    };

    // Start Abacus: ha_pulse_shared_tripboard_ab_test
    hasShareModal = () => {
        return this.isSharedTestOn();
    };
    // End Abacus: ha_pulse_shared_tripboard_ab_test

    getHitProps = (hit, idx, hits) => {
        const {
            boardId,
            endDate,
            startDate,
            heartRemoveTestValue,
            role,
            adultsCount,
            childrenCount,
            petsIncluded
        } = this.props;
        const isDated = !!(startDate && endDate);
        const isHeartRemoveTestOn = heartRemoveTestValue > 0;
        const handleHitClick = () => {
            edap.listingClick(boardId, hit.listingId, idx, hits.length);
        };
        const handleDeleteClick = () => {
            this.props.onDelete(boardId, hit.listingId);
            edap.listingDelete(boardId, hit.listingId, idx, hits.length, role);
        };
        const formattedStartDate = TripboardDetails.formatTripboardDate(startDate);
        const formattedEndDate = TripboardDetails.formatTripboardDate(endDate);
        const urlParts = (hit.detailPageUrl || '').split('?');
        const rawURL = urlParts[0];
        const rawParams = urlParts[1] || '';

        let searchParams = queryString.parse(rawParams);
        if (isDated) {
            searchParams.arrivalDate = formattedStartDate;
            searchParams.departureDate = formattedEndDate;
        } else {
            searchParams.noDates = true;
        }

        if (adultsCount) {
            searchParams.adultsCount = adultsCount;
        }
        if (childrenCount) {
            searchParams.childrenCount = childrenCount;
        }
        if (petsIncluded) {
            searchParams.petsIncluded = petsIncluded;
        }

        const detailPageUrl = `${rawURL}?${queryString.stringify(searchParams)}`;

        // [SCRATCHPAD-1467] temp logging to further debug
        if (!hit.detailPageUrl) {
            logNoListingUrl(boardId, hit.listingId);
        }

        return {
            ...hit,
            galleryUrl: getImageUrl(hit.galleryUrl), // this reconstructs this URL to request c6 (smaller images)
            thumbnailUrl1: getImageUrl(hit.thumbnailUrl1),
            thumbnailUrl2: getImageUrl(hit.thumbnailUrl2),
            thumbnailUrl3: getImageUrl(hit.thumbnailUrl3),
            arrivalDate: this.props.startDate,
            departureDate: this.props.endDate,
            unit: hit.unitUuid,
            detailPageUrl,
            scratchpadId: hit.listingId, // react-hit-scratchpad invokes onClick callback with event + this ID
            gallery: true,
            isDated,
            showHeadline: true,
            siteDisplayName: this.props.siteDisplayName,
            onClick: handleHitClick,
            onDelete: this.hasDeleteButton() ? handleDeleteClick : null,
            hasDeleteButton: this.hasDeleteButton(),
            hasTripboardButton: this.hasTripboardButton(),
            hasCarousel: this.isCarouselTestOn(),
            isHeartRemoveTestOn,
            idx,
            hitTotal: hits.length
        };
    };

    renderHit = (hit, idx, hits) => {
        const hitProps = this.getHitProps(hit, idx, hits);

        return (
            <div className="trip-board-details__hit" key={hit.listingId}>
                <Hit {...hitProps} />
            </div>
        );
    };

    render() {
        const {
            adultsCount,
            boardId,
            childrenCount,
            currency,
            emptySearchTestValue,
            endDate,
            guestContextTestValue,
            listings,
            listingIds,
            isShared,
            loadingState,
            locale,
            name,
            petsIncluded,
            publicSearchTestValue,
            privateSearchTestValue,
            places,
            role,
            refetchTripboard,
            siteName,
            startDate,
            sharedTestValue,
            similarPropertiesTestValue,
            mapTestValue,
            user,
            users
        } = this.props;

        const isSimilarPropertytestOn = similarPropertiesTestValue > 0;
        const isEmptySearchTestOn = emptySearchTestValue > 0;
        const isPublicSearchTestOn = publicSearchTestValue > 0;
        const isPrivateSearchTestOn = privateSearchTestValue > 0;
        const isGuestContextTestOn = guestContextTestValue > 0;

        if (loadingState.isNotFound) {
            return <Redirect to={routes.TRIPBOARD} />;
        }

        const collaboratorType = (user && user.isViewer) ? CollaborateType.SHARE : CollaborateType.INVITE;

        // Start Abacus: ha_pulse_shared_tripboard_ab_test
        const contentRowClass = classnames('row', {
            'remove-container-padding grey-background': sharedTestValue === 2
        });

        const contentRowClassPlusPadding = classnames(contentRowClass, 'row--padded');

        const contentColClass = classnames('col-lg-10 col-lg-offset-1', {
            'trip-board-details__content': sharedTestValue === 2,
            'with-loading-overlay': true
        });

        const headerRowClass = classnames('row header-container', {
            'share-var-2 remove-container-padding': sharedTestValue === 2
        });

        // End Abacus: ha_pulse_shared_tripboard_ab_test
        const showEmptyStateSearch = loadingState.isSuccess && listings.length === 0 && isEmptySearchTestOn;
        const translations = this.translations;

        return (
            <div className="trip-board-details__container">
                {boardId && <ActivityIndicatorSeen boardId={boardId} />}
                <ErrorBoundary>
                    {boardId && <InviteAccept boardId={boardId} endDate={endDate} startDate={startDate} />}
                    <div className={headerRowClass}>
                        <div className="col-lg-10 col-lg-offset-1">
                            {/*
                                Check role; Temp fix for server-side render
                                TODO: We need a better strategy.
                                Figure this out in next iteration
                                of SSR ab test.
                            */}
                            <RolePermissions role={role} viewer>
                                <TripboardBanner />
                            </RolePermissions>
                            <div className="trip-board-details__header">
                                <div className="row">
                                    <FavoritesMessage isShared={isShared} />
                                </div>
                                <HeaderWithEditState
                                    boardId={boardId}
                                    collaboratorType={collaboratorType}
                                    endDate={endDate}
                                    listings={listings}
                                    name={name}
                                    role={role}
                                    startDate={startDate}
                                    users={users}
                                    showEmptyStateSearch={showEmptyStateSearch}
                                />
                                {!showEmptyStateSearch && (
                                    <RolePermissions role={role} collaborator owner>
                                        <div className="row">
                                            <StayContextContainer
                                                adultsCount={adultsCount}
                                                boardId={boardId}
                                                childrenCount={childrenCount}
                                                endDate={endDate}
                                                locale={locale}
                                                petsIncluded={petsIncluded}
                                                startDate={startDate}
                                                isGuestContextTestOn={isGuestContextTestOn}
                                                currency={currency}
                                                refetchTripboard={refetchTripboard}
                                            />
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xlg-8 text-right">
                                                <div className="flex-align-center flex-align-items-center flex-end flex-row padding-top-1x">
                                                    <CollaboratorDisplay users={users} />
                                                    <CollaborateButton
                                                        boardId={boardId}
                                                        endDate={endDate}
                                                        startDate={startDate}
                                                        type={collaboratorType}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </RolePermissions>
                                )}
                                <React.Fragment>
                                    <CollaborateModal
                                        boardId={boardId}
                                        endDate={endDate}
                                        listings={listings}
                                        name={name}
                                        role={role}
                                        startDate={startDate}
                                    />
                                </React.Fragment>
                            </div>
                            {mapTestValue > 0 &&
                            loadingState.isSuccess &&
                            listings.length > 0 && (
                                <TabNavigation
                                    mapTestValue={mapTestValue}
                                    translations={translations}
                                    onTabClick={this.onTabClick}
                                    displayIndex={this.state.displayIndex}
                                />
                            )}
                        </div>
                    </div>
                    <div className={contentRowClass}>
                        <div className={contentColClass}>
                            <LoadingOverlay loading={loadingState.isStart} />
                            {loadingState.isError && <GenericError />}
                            {loadingState.isSuccess &&
                            listings.length === 0 &&
                            !showEmptyStateSearch && (
                                <React.Fragment>
                                    <PageView pagename={PAGE_TRIPBOARD_DETAILS} />
                                    <NoListingsGraphic />
                                </React.Fragment>
                            )}
                            {showEmptyStateSearch && (
                                <React.Fragment>
                                    <PageView pagename={PAGE_TRIPBOARD_DETAILS} />
                                    <RolePermissions role={role} owner collaborator>
                                        <NoListingsSearch
                                            boardCheckIn={startDate}
                                            boardCheckOut={endDate}
                                            boardId={boardId}
                                            locale={locale}
                                            siteName={siteName}
                                            role={role}
                                            translations={translations}
                                            edapSearchType={'tripboard empty search bar'}
                                        />
                                    </RolePermissions>
                                </React.Fragment>
                            )}
                            {loadingState.isSuccess &&
                            listings.length > 0 && (
                                <div className="trip-board-details__hits">
                                    {this.showDetails() && (
                                        <React.Fragment>
                                            <PageView pagename={PAGE_TRIPBOARD_DETAILS} />
                                            {listings.map(this.renderHit)}
                                        </React.Fragment>
                                    )}
                                    {!this.showDetails() && (
                                        <div className="trip-board-details__map">
                                            <PageView pagename={PAGE_TRIPBOARD_DETAILS_MAP} />
                                            <ListingsMap
                                                boardId={boardId}
                                                channel={GOOGLE_MAPS_CHANNEL_ID}
                                                listings={listings}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {(isPublicSearchTestOn || isPrivateSearchTestOn) && (
                        <div className="row">
                            <div className="col-lg-10 col-lg-offset-1">
                                {listings.length !== 0 && (
                                    <React.Fragment>
                                        {isPublicSearchTestOn && (
                                            <RolePermissions role={role} viewer>
                                                <PublicSearch
                                                    boardCheckIn={startDate}
                                                    boardCheckOut={endDate}
                                                    boardId={boardId}
                                                    locale={locale}
                                                    siteName={siteName}
                                                    role={role}
                                                    translations={translations}
                                                    edapSearchType={'tripboard public search bar'}
                                                />
                                            </RolePermissions>
                                        )}
                                        {isPrivateSearchTestOn && (
                                            <RolePermissions role={role} owner collaborator>
                                                <PrivateSearch
                                                    adultsCount={adultsCount}
                                                    childrenCount={childrenCount}
                                                    petIncluded={petsIncluded}
                                                    boardCheckIn={startDate}
                                                    boardCheckOut={endDate}
                                                    boardId={boardId}
                                                    locale={locale}
                                                    siteName={siteName}
                                                    role={role}
                                                    searchBoxVariant={privateSearchTestValue}
                                                    numPlaces={5}
                                                    places={places}
                                                    edapSearchType={'tripboard private search bar'}
                                                />
                                            </RolePermissions>
                                        )}
                                    </React.Fragment>
                                )}
                                {listings.length === 0 &&
                                isPublicSearchTestOn && (
                                    <RolePermissions role={role} viewer>
                                        <NoListingsSearch
                                            boardCheckIn={startDate}
                                            boardCheckOut={endDate}
                                            boardId={boardId}
                                            locale={locale}
                                            siteName={siteName}
                                            role={role}
                                            translations={translations}
                                            edapSearchType={'tripboard public search bar'}
                                        />
                                    </RolePermissions>
                                )}
                            </div>
                        </div>
                    )}
                    {isSimilarPropertytestOn && (
                        <div className={contentRowClassPlusPadding}>
                            <RecommendedPropertyCarousel
                                stay={{
                                    dateRange: {arrival: startDate, departure: endDate},
                                    adultsCount,
                                    childrenCount,
                                    petsIncluded
                                }}
                                boardId={boardId}
                                listingIds={listingIds}
                                maxProperties={12}
                            />
                        </div>
                    )}
                    <CommentsModal />
                    <ListingDeleteModal userRole={role} onDelete={this.props.onDelete} />
                </ErrorBoundary>
            </div>
        );
    }
}

export default compose(
    withPAR,
    withAbacusTestValuesAsProps({
        [HA_PULSE_EMPTY_SEARCH_TEST]: 'emptySearchTestValue',
        [HA_PULSE_PUBLIC_SEARCH_TEST]: 'publicSearchTestValue',
        [HA_PULSE_PRIVATE_SEARCH_TEST]: 'privateSearchTestValue',
        [HA_PULSE_GOOGLE_MAP]: 'mapTestValue',
        [HA_PULSE_SHARED_TRIPBOARD_AB_TEST]: 'sharedTestValue',
        [HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE]: 'shareButtonToggleValue',
        [HA_PULSE_TRIPBOARDS_CAROUSEL_TEST]: 'carouselTestValue',
        [HA_PULSE_REMOVE_BACK_BUTTON_TEST]: 'removeBackButtonTestValue',
        [HA_PULSE_SIMILAR_PROPERTIES]: 'similarPropertiesTestValue',
        [HA_PULSE_HEART_REMOVE_TEST]: 'heartRemoveTestValue',
        [HA_PULSE_GUEST_CONTEXT_TEST]: 'guestContextTestValue'
    })
)(TripboardDetails);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/details.js